import { toValue, MaybeRef } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { whenAuthenticated } from '@/utils/query-utils'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'

export const useReportsListQuery = (
    plantSids: MaybeRef<number[]>,
    componentTypes: MaybeRef<number[]>,
    reportType: MaybeRef<number | undefined>,
    startDate: MaybeRef<string | undefined>,
    endDate: MaybeRef<string | undefined>,
) => {
    return useQuery({
        queryKey: ['reports', plantSids, componentTypes, reportType, startDate, endDate, 'list-reports'],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.reportsApi.listReports(
                toValue(componentTypes),
                toValue(plantSids),
                toValue(reportType),
                toValue(startDate),
                toValue(endDate),
                undefined,
                undefined,
                0,
                0,
                undefined,
                undefined,
                undefined,
                { signal },
            )
            return result
        },
        enabled: whenAuthenticated,
    })
}
